'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LogentryModel = require('../model/LogentryModel');

var _LogentryModel2 = _interopRequireDefault(_LogentryModel);

var _TimestampControl = require('../../../lib/ui/TimestampControl');

var _TimestampControl2 = _interopRequireDefault(_TimestampControl);

var _TextAreaControl = require('../../../lib/ui/TextAreaControl');

var _TextAreaControl2 = _interopRequireDefault(_TextAreaControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LogentryForm = function () {
  function LogentryForm(element, args) {
    _classCallCheck(this, LogentryForm);

    var fieldsetLogentry = document.createElement('fieldset');
    var legendLogentry = document.createElement('legend');
    legendLogentry.innerHTML = 'Logboekregel';
    fieldsetLogentry.appendChild(legendLogentry);

    this.id = args.logentry.values.id;
    this.target_id = args.logentry.values.target_id;
    this.object_type_id = args.logentry.values.object_type_id;

    this.timestamp = new _TimestampControl2.default(fieldsetLogentry, { label: 'Tijdstempel', value: args.logentry.values.timestamp, readonly: window.PRIM.hasReadonlyModuleAccess('logentries'), onchange: args.onchange });
    this.description = new _TextAreaControl2.default(fieldsetLogentry, { label: 'Omschrijving', value: args.logentry.values.description, readonly: window.PRIM.hasReadonlyModuleAccess('logentries'), onchange: args.onchange });

    var fragment = document.createDocumentFragment();
    fragment.appendChild(fieldsetLogentry);

    element.appendChild(fragment);
  }

  _createClass(LogentryForm, [{
    key: 'getValue',
    value: function getValue() {
      var logentry = new _LogentryModel2.default();
      logentry.values.id = this.id;
      logentry.values.target_id = this.target_id;
      logentry.values.object_type_id = this.object_type_id;
      logentry.values.timestamp = this.timestamp.getValue();
      logentry.values.description = this.description.getValue();
      return logentry;
    }
  }, {
    key: 'setValue',
    value: function setValue(logentry) {
      this.id = logentry.values.id;
      this.target_id = logentry.values.target_id;
      this.object_type_id = logentry.values.object_type_id;
      this.timestamp.setValue(logentry.values.timestamp);
      this.description.setValue(logentry.values.description);
    }
  }]);

  return LogentryForm;
}();

exports.default = LogentryForm;


//////////////////
// WEBPACK FOOTER
// ./js/modules/logentry/ui/LogentryForm.js
// module id = 67
// module chunks = 0